// @flow
import * as React from 'react';

import { useTranslator } from '@gandi/translate';

type GetMailboxLabel = (name: string, capacity: string) => string;

export default function useMailboxLabel(): GetMailboxLabel {
  const { __ } = useTranslator();

  return React.useCallback<GetMailboxLabel>(
    (name, capacity) => {
      const byConfig = {
        standard: __('Standard'),
        premium: __('Premium'),
      };

      // $FlowFixMe[invalid-computed-prop]
      const label = name in byConfig ? byConfig[name] : name;
      return __('%(name)s %(capacity)s', { name: label, capacity });
    },
    [__],
  );
}
